import { motion } from 'framer-motion';
import React from 'react';
import { ReactComponent as ClockIcon } from '../../Icons/clockIcon.svg';
import { ReactComponent as ReadIcon } from '../../Icons/readIcon.svg';
import '../../Styles/Blog/Blog.css';

const BookingBlog = () => {
    return (
        <div className="blog-item-main-container flex-box">
            <motion.div className="blog-item-content-wrapper" initial={{ y: `-900%`, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.5, delay: 0.7 }}>
                <h4 className="blog-item-title">
                    <span onClick={() => window.open(`https://asguru.hashnode.dev/clone-of-bookingcom`)} className="pointer">Clone of Booking.com</span>
                </h4>
                <p className="blog-item-brief-view flex-box">
                    <span className="flex-box pointer" onClick={() => window.open(`https://asguru.hashnode.dev/clone-of-bookingcom`)}>
                        <span className="flex-box blog-item-publish-date">Mar 15, 2021</span>
                        <span className="flex-box blog-item-minutes-of-read">
                            <ClockIcon />
                            5 min read
                        </span>
                        <span className="flex-box blog-item-number-of-views">
                            <ReadIcon />
                            336 views
                        </span>
                    </span>
                </p>
                <p onClick={() => window.open(`https://asguru.hashnode.dev/clone-of-bookingcom`)} className="pointer">
                    Booking.com, Final destination for all travelers, where they will get information of hotel and lodging details of various cities
                    in 43 different languages, Me and my team built this application in under a week, Used HTML5, CSS3 and JavaScript to make it happen,
                    Hope you enjoy reading this blog, Happy reading 😀.
                </p>
            </motion.div>
            <motion.div
                className="blog-item-image-wrapper flex-box pointer"
                onClick={() => window.open(`https://asguru.hashnode.dev/clone-of-bookingcom`)}
                initial={{ y: `-900%`, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.7 }}
            >
                <img className="blog-item-image-box" src={process.env.PUBLIC_URL + '/Images/bookingBlogCover.png'} alt="booking blog" />
            </motion.div>
        </div>
    )
}

export default BookingBlog
